/**
 * <StudentName
 *		// please describe props here
 *	/>
 *
 * - When there is a nesting tr, we use tbody as a row.
 *
 * @parent anybody
 * @children
 * @stateful
 * @stateless
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import StudentInfoDock from 'template/Docks/StudentInfo';
import Student from 'mediators/Student';
import './StudentName.scss';
import __R, { userCan } from 'containers/__R'

class StudentName extends React.Component {
  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);

  }

  componentWillMount() {

  }

  onClick() {
    const { id, name, checkStudentUpdate } = this.props;

    StudentInfoDock({ id, name })
    .then(res=>{
      checkStudentUpdate(res.isUpdated)
    })
  }

  render() {
    const {name} = this.props;

    return (
      <__R can='read_student_detail' by='disable'>
        <button className='btn-link studentName' onClick={this.onClick}>{name}</button>
      </__R>
    )
  }
}

export default StudentName;



// WEBPACK FOOTER //
// ./src/components/StudentName/index.js